export const footerConstants = {
  linkList: [
    {
      text: 'Learn more',
      // link: 'https://www.gehealthcare.com/digital-expert',
      link: 'https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert',
      target: '_blank',
    },
    {
      text: 'Support',
      link: '',
    },
    {
      text: 'Contact Sales',
      link: 'https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert',
      target: '_blank',
    },
    {
      text: 'Privacy Policy',
      link: 'https://www.ge.com/privacy',
      target: '_blank',
    },
  ]
}